import { createFileRoute, redirect } from '@tanstack/react-router'

// /coach/ сам по себе бесполезен — тренер заходит либо в конкретный магазин,
// либо в список магазинов. Редирект ставим на уровне роутера, чтобы не
// мигать «пустой кабинет» при прямом заходе на /coach.
export const Route = createFileRoute('/coach/')({
  beforeLoad: () => {
    throw redirect({ to: '/coach/stores' })
  },
})
